export const serializeItem = (item) => {
  return item.yearFrom + "-" + item.yearTo;
};
